import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./styles.css";
import Image from "../../components/Image";
import {
    checkAndSetStats,
    isMobileUserAgent,
    scrollToElement,
} from "../../helpers/helpers";
import diamondsBlurred from "../../images/diamondsBlurred.png";
import { Button } from "primereact/button";
import ParallaxImage from "../../components/ParallaxImage";
import MovingComponent from "../../components/MovingComponent";
import InfiniteCarousel from "../../components/InfiniteCarousel";
import ContactMeBlock from "../../components/ContactMeBlock";
import { get, ref } from "firebase/database";
import { database } from "../../firebase";
import OrderBlock from "../../components/OrderBlock";
import { Sidebar } from "primereact/sidebar";
import SizeSidebar from "../../components/SizeSidebar";
import { useNavigate } from "react-router-dom";
import ProductLuxury from "../../components/ProductLuxury";
import Navigation from "../../components/Navigation";
import SEO from "../../components/SEO";

function Diamonds() {
    const navigate = useNavigate();
    const doesStatsSent = useRef(false);
    const isMobile = isMobileUserAgent();
    const [isLoading, setIsLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [imagesList, setImagesList] = useState(null);
    const [contactVisible, setContactVisible] = useState(false);
    const [isOrderVisible, setIsOrderVisible] = useState(false);
    const [isSizeVisible, setIsSizeVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#131213";
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        const dbRefDiamonds = ref(database, `/CVD/products`);
        const dbRefImagesDiamonds = ref(database, `/CVD/images`);

        get(dbRefDiamonds)
            .then((snapshot) => {
                if (snapshot.exists()) {
                    setProducts(snapshot.val());
                } else {
                    console.log("No data available");
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => setIsLoading(false));

        get(dbRefImagesDiamonds).then((snapshot) => {
            if (snapshot.exists()) {
                setImagesList(snapshot.val());
            } else {
                console.log("No data available");
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!doesStatsSent.current) {
            checkAndSetStats("diamondsPage");
            doesStatsSent.current = true;
        }
    }, []);

    const getDefaultImage = (image) => {
        return imagesList ? image : diamondsBlurred;
    };

    return (
        <div
            className={`flex justify-center flex-col bg-diamondsBg cursor-default`}
        >
            <SEO
                title="CVD-діаманти — Етичні лабораторні діаманти"
                description="CVD-діаманти від TSATSKY — етичні, екологічні та доступні лабораторні діаманти. Прикраси нового покоління з сертифікованими CVD-діамантами."
                url="/diamonds"
                collection={{ name: "CVD-діаманти", description: "Етичні лабораторні діаманти" }}
            />
            <Navigation showBack backTo="/" variant="dark" />
            <div className="flex justify-center flex-col w-fit lg:w-full mb-12 px-6 xl:px-24 pt-14 xl:pt-36 gap-0 lg:gap-7 text-[#A7A7A4]">
                <div className="flex justify-center flex-col lg:flex-row">
                    <div className="flex justify-center lg:justify-start flex-col lg:w-1/2 w-full">
                        <div className="text-xs">
                            Відкрийте для себе красу CVD Діамантів
                        </div>
                        <div className="mt-6">
                            <span className="text-[32px] lg:text-[90px] text-white font-semibold font-sans leading-10 lg:leading-[90px]">
                                {isMobile
                                    ? "Досконалість технологій: CVD-діаманти від TSATSKY"
                                    : "CVD-діаманти від TSATSKY"}
                            </span>
                        </div>
                        <div className="leading-[120%] lg:leading-8 text-justify mt-4">
                            Етичні, екологічно чисті та інноваційні діаманти,
                            створені за найсучаснішими технологіями у власному
                            виробництві TSATSKY. Це прикраси нового покоління —
                            для тих, хто цінує стиль, свідомий вибір і справжню
                            якість.
                        </div>

                        <Button
                            label="Обрати прикрасу"
                            onClick={() =>
                                scrollToElement("diamonds-catalogue")
                            }
                            className="rounded-[100px] font-semibold lg:rounded-none shadow-none mt-6 py-3 lg:py-4 px-5 lg:px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-full lg:w-fit"
                        />

                        <Button
                            label="Переглянути інші коллекції"
                            onClick={() => navigate("/")}
                            className="rounded-[100px] lg:hidden block font-semibold lg:rounded-none shadow-none mt-6 py-3 lg:py-4 px-5 lg:px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-full lg:w-fit"
                        />

                        <div className="text-xs mt-5 lg:mt-9">
                            Відсвяткуйте своє кохання з нашим сяйвом
                        </div>
                    </div>

                    <div className="flex justify-center lg:justify-end items-center lg:w-1/2 w-full h-full">
                        {isMobile ? (
                            <MovingComponent
                                startPosition={0}
                                direction="down"
                                speedFactor={1.5}
                            >
                                <img
                                    src={getDefaultImage(
                                        imagesList?.firstImage
                                    )}
                                    className="object-contain"
                                    alt="First Ring"
                                />
                            </MovingComponent>
                        ) : (
                            <ParallaxImage
                                // className=""
                                parallaxIntensity={120}
                                slideDirection="left"
                            >
                                <img
                                    src={getDefaultImage(
                                        imagesList?.firstImage
                                    )}
                                    className="object-contain"
                                    alt="First Ring"
                                />
                            </ParallaxImage>
                        )}
                    </div>
                </div>

                <div className="flex flex-col lg:flex-row justify-center items-center mt-10 lg:mt-[100px] gap-[10%]">
                    <div className="flex justify-center lg:w-1/2 w-full mt-5 lg:mt-0 h-full">
                        {isMobile ? (
                            <MovingComponent
                                startPosition={0}
                                speedFactor={1.5}
                            >
                                <img
                                    src={getDefaultImage(
                                        imagesList?.secondImage
                                    )}
                                    className="object-contain"
                                    alt="Second Ring"
                                />
                            </MovingComponent>
                        ) : (
                            <ParallaxImage
                                // className="shadow-2xl"
                                parallaxIntensity={120}
                                slideDirection="right"
                            >
                                <img
                                    src={getDefaultImage(
                                        imagesList?.secondImage
                                    )}
                                    className="object-contain"
                                    alt="Second Ring"
                                />
                            </ParallaxImage>
                        )}
                    </div>

                    <div className="flex justify-center flex-col lg:w-1/2 w-full">
                        <div className="mt-5 lg:mt-0">
                            <span className="text-[39px] lg:text-[54px] text-white font-semibold font-sans leading-[60px]">
                                Чому обирають CVD-діаманти?
                            </span>
                        </div>
                        <div className="leading-8 text-justify mt-4">
                            <ul class="benefits-list text-left">
                                <li>
                                    <span class="benefit-title">
                                        Екологічність
                                    </span>
                                    <span class="benefit-description">
                                        Виробництво без шкоди для природи та без
                                        забруднення довкілля.
                                    </span>
                                </li>
                                <li>
                                    <span class="benefit-title">Етичність</span>
                                    <span class="benefit-description">
                                        Жодної «кривавої» історії або
                                        експлуатації праці.
                                    </span>
                                </li>
                                <li>
                                    <span class="benefit-title">
                                        Доступність
                                    </span>
                                    <span class="benefit-description">
                                        Ціна на 20–30% нижча порівняно з
                                        природними алмазами.
                                    </span>
                                </li>
                                <li>
                                    <span class="benefit-title">Якість</span>
                                    <span class="benefit-description">
                                        Висока прозорість та чистота, стандарт
                                        типу IIa.
                                    </span>
                                </li>
                            </ul>
                        </div>

                        <div className="mt-5 lg:mt-0 mb-8 lg flex gap-4">
                            <Button
                                label="Переглянути каталог"
                                onClick={() =>
                                    scrollToElement("diamonds-catalogue")
                                }
                                className="rounded-[100px] shadow-none mt-0 lg:mt-6 font-semibold lg:rounded-none py-4 px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-fit"
                            />
                            <Button
                                label="Визначити розмір"
                                onClick={() => setIsSizeVisible(true)}
                                className="rounded-[100px] shadow-none mt-0 lg:mt-6 font-semibold lg:rounded-none py-4 px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-fit"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-center items-center flex-col gap-3 font-sans py-10 bg-white">
                <div className="text-xs text-[#A7A7A4]">
                    Ознайомтесь з нашим каталогом
                </div>
                <div className="text-[32px] lg:text-[53px] leading-[120%] text-center font-semibold">
                    Відкрийте для себе світ CVD-діамантів
                </div>
                <div className="text-xs">
                    Перегляньте нашу колекцію CVD діамантів
                </div>
            </div>

            <div
                className="text-[#A7A7A4] flex flex-col items-center lg:flex-row"
                id="info"
            >
                <div className="flex justify-center items-center flex-col w-full lg:w-1/2 py-4">
                    <div className="max-w-[433px] py-10 px-5 lg:py-0 lg:px-0">
                        <div className="text-xs">Вічна вишуканість</div>
                        <div className="mt-5 lg:mt-5">
                            <span className="text-[39px] lg:text-[54px] text-white font-semibold font-sans leading-[60px]">
                                Що таке CVD-діаманти?
                            </span>
                        </div>
                        <div className="leading-8 text-justify mt-5">
                            CVD (Chemical Vapor Deposition) — це екологічний
                            метод вирощування діамантів у лабораторних умовах,
                            де атоми вуглецю осідають на підкладку, формуючи
                            кристал. Результат — діамант, ідентичний природному
                            за хімічними та фізичними властивостями, але
                            створений без шкоди для природи та суспільства.
                        </div>

                        <div className="mt-4 lg:mt-10 lg flex gap-4">
                            <Button
                                onClick={() =>
                                    scrollToElement("diamonds-catalogue")
                                }
                                label="Перейти до каталогу"
                                className="rounded-[100px] shadow-none mt-0 lg:mt-6 font-semibold py-2.5 lg:py-4 px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-fit"
                            />
                            <Button
                                onClick={() =>
                                    scrollToElement("diamonds-catalogue")
                                }
                                label="Купити зараз"
                                className="rounded-[100px] mt-0 lg:mt-6 shadow-none font-semibold py-2.5 lg:py-4 px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-fit"
                            />
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-1/2">
                    <Image
                        highQualitySrc={getDefaultImage(
                            imagesList?.whatIsRightImage
                        )}
                        // lowQualitySrc={historyItem?.imageLow}
                        alt="Third Ring"
                    />
                </div>
            </div>
            <div
                className="diamonds_separator bg-center bg-cover flex justify-center font-sans p-4 lg:p-0"
                style={{
                    backgroundImage: imagesList?.personBackgroundImage
                        ? `url(${imagesList?.personBackgroundImage})`
                        : "none",
                }}
            >
                <div className="max-w-[525px] mt-32 mb-20 flex flex-col justify-center items-center">
                    <div className="mt-5 lg:mt-5 text-center">
                        <span className="text-[39px] lg:text-[54px] text-white font-semibold font-sans leading-[60px]">
                            Досконалість у деталях
                        </span>
                    </div>

                    <div className="leading-8 mt-6 text-white text-center font-extralight">
                        Відкрийте для себе витончену розкіш прикрас з
                        CVD-діамантами — технологічну чистоту, етичність і
                        красу, яку неможливо не помітити. Прикраси, створені
                        надихати.
                    </div>

                    <Button
                        label="Переглянути колекцію"
                        onClick={() => scrollToElement("diamonds-catalogue")}
                        className="rounded-[100px] shadow-none mt-8 py-4 px-6 border hover:shadow-lg shadow-black bg-white text-[#8D8C8C] hover:text-black w-fit"
                    />
                </div>
            </div>
            <div className="bg-white flex flex-col items-center font-sans text-[#868486]">
                <div className="text-center mt-16">
                    <div className="text-xs">Сяючий блиск</div>
                    <div className="mt-2 lg:mt-2">
                        <span className="text-[39px] lg:text-[54px] text-black font-semibold font-sans leading-[60px]">
                            Дізнайся ще більше про CVD-Діаманти
                        </span>
                    </div>
                    <div className="leading-8 mt-4 text-center font-extralight">
                        Зроби крок у сучасність разом з нами
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-24 p-4 lg:p-0">
                    {[
                        {
                            title: "Гарантія якості",
                            buttonTitle: "Замовити зараз",
                            onClick: () =>
                                scrollToElement("diamonds-catalogue"),
                            description:
                                "Кожна прикраса супроводжується сертифікатом авторитетної гемологічної лабораторії (GIA або IGI), що підтверджує характеристики діаманта. Ми також надаємо гарантію на всі вироби та пропонуємо професійний догляд.",
                        },
                        {
                            title: "Власне виробництво",
                            buttonTitle: "Замовити консультацію",
                            onClick: () => setContactVisible(true),
                            description:
                                "TSATSKY — це не просто бренд, це ще й Харківська Ювелірна Фабрика з багаторічним досвідом. Ми контролюємо кожен етап створення прикрас, забезпечуючи високу якість та унікальний дизайн. Щоб наші клієнти були у максимальному захваті від прикрас.",
                        },
                        {
                            title: "Різноманітний вибір",
                            buttonTitle: "Визначити розмір",
                            onClick: () => setIsSizeVisible(true),
                            description:
                                "Пропонуємо різноманіття прикрас з CVD-діамантами: Каблучки, сережки, кулони та кольє. Знайдіть для себе класичні та дизайнерськи моделі, витончені та сучасні варианти, символи любові та стилю, а також елегантні акценти до будь-якого образу.",
                        },
                    ].map((item) => (
                        <div className="flex flex-col justify-center items-center text-center mt-11 min-w-[300px]">
                            <div>
                                <span className="text-[34px] text-black font-semibold text-nowrap">
                                    {item.title}
                                </span>
                            </div>
                            <div className="text-[#A3A1A5] w-full lg:w-[300px] mt-4 min-h-[195px]">
                                {item.description}
                            </div>
                            <Button
                                label={item.buttonTitle}
                                onClick={() => item.onClick()}
                                className="rounded-none shadow-none lg:rounded-[100px] mt-6 py-2 lg:py-4 px-6 hover:shadow-lg shadow-black bg-black text-[#DCDCDB] hover:text-white w-full lg:w-fit"
                            />
                        </div>
                    ))}
                </div>
                <div className="my-8 lg:my-28">
                    <InfiniteCarousel
                        imageUrl={getDefaultImage(imagesList?.carouselUrl)}
                    />
                </div>
            </div>

            <div>
                <div className="grid grid-cols-1 md:grid-cols-2 overflow-hidden relative">
                    <ParallaxImage
                        parallaxIntensity={600}
                        slideDirection="right"
                        startFromZero
                    >
                        <div className="relative z-10">
                            <div className="absolute z-10 bottom-12 w-full">
                                <div className="w-full flex flex-col text-left mx-8 lg:mx-[10%]">
                                    <div className="text-xs text-[#B7B4B0]">
                                        Незаперечна краса
                                    </div>
                                    <div className="mt-0 lg:mt-4">
                                        <span className="text-[39px] lg:text-[54px] text-white font-semibold font-sans leading-[60px]">
                                            Вишуканий стиль
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <Image
                                highQualitySrc={getDefaultImage(
                                    imagesList?.movingImageLeft
                                )}
                                // lowQualitySrc={historyItem?.imageLow}
                                alt="Ring Four"
                            />
                        </div>
                    </ParallaxImage>
                    <div className="text-white font-sans text-center absolute w-full p-12 top-64 z-0 text-xl font-bold">
                        Подаруй диво СВОЇМ
                    </div>
                    <ParallaxImage
                        parallaxIntensity={600}
                        slideDirection="left"
                        startFromZero
                    >
                        <div className="relative z-10">
                            <Image
                                highQualitySrc={getDefaultImage(
                                    imagesList?.movingImageRight
                                )}
                                // lowQualitySrc={historyItem?.imageLow}
                                alt="Ring Five"
                            />
                        </div>
                    </ParallaxImage>

                    <div className="text-white text-center absolute w-full bottom-16 z-0 p-12 text-xl font-bold">
                        Переглянь каталог та обери прикрасу, яка розповість про
                        почуття.<br></br>{" "}
                        <div className="mt-4 text-3xl">❤️</div>
                    </div>
                </div>
            </div>

            <div className="bg-white flex flex-col items-center font-sans text-[#868486]">
                <div className="text-center mt-16 mb-10">
                    <div className="text-xs">Виділяйся серед інших</div>
                    <div className="mt-2 lg:mt-2">
                        <span className="text-[39px] lg:text-[54px] text-black font-semibold font-sans leading-[60px]">
                            Відчуй якість прикрас на собі
                        </span>
                    </div>
                    <div className="leading-8 mt-4 text-center font-extralight">
                        Вишуканість у кожній деталі
                    </div>
                </div>
            </div>

            <div>
                {isLoading ? (
                    <div className="w-full text-center text-white py-4">
                        Loading...
                    </div>
                ) : (
                    <div
                        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-10 sm:gap-24 p-4 lg:py-0 lg:px-10"
                        id="diamonds-catalogue"
                    >
                        {products.map((item, index) => (
                            <ProductLuxury
                                item={item}
                                onButtonClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedItem(item);
                                    setIsOrderVisible(true);
                                }}
                            />
                        ))}
                    </div>
                )}
            </div>
            <Sidebar
                className={isMobile ? "" : "w-1/2"}
                position="right"
                visible={contactVisible}
                onHide={() => setContactVisible(false)}
                fullScreen={isMobile}
            >
                <ContactMeBlock />
            </Sidebar>

            <Sidebar
                className={isMobile ? "" : "w-1/2"}
                position="right"
                visible={isOrderVisible}
                onHide={() => setIsOrderVisible(false)}
                fullScreen={isMobile}
            >
                <OrderBlock product={selectedItem} />
            </Sidebar>

            <SizeSidebar
                isVisible={isSizeVisible}
                setIsVisible={setIsSizeVisible}
            />
        </div>
    );
}

export default Diamonds;
